import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { makeStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backgroundColor: alpha(theme.palette.primary.main, 0.5),
  },
}));

export default function DeleteDialog(props) {
  const classes = useStyles();
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        className: classes.backdrop
      }}
    >
      <DialogTitle id="alert-dialog-title">{props.title || 'Tem certeza?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.children && props.children}
          {!props.children && (props.message || 'Confirme para excluir')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={props.handleConfirm} color="primary" autoFocus>
          {props.deleteText || 'Excluir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
